import jwt_decode from "jwt-decode";

export function getIsTokenExpired(token: string): boolean {
  const decodedToken = jwt_decode(token);
  const currentUnixTime = Math.floor(Date.now() / 1000);
  return (decodedToken as any).exp < currentUnixTime;
}
